<template>
  <div class="form-outline mb-3 mt-5 d-flex justify-content-between" style="display: flex!important;justify-content: space-between!important; margin: 20px auto; padding-left: 0">
    <label for="coupon" class="text-nowrap mb-2">have a coupon ? </label>
    <input type="text" placeholder="Coupon code" class="form-control" @keyup="checkCouponIsValid" v-model="couponCode">
  </div>
  <div class="mb-1 mt-1 d-flex justify-content-between" style="padding-left: 0" v-if="couponMessage"><small style="color: var(--primary)">{{ couponMessage }}</small></div>
</template>

<script>
export default {
  name: "couponInputComponent",
  data() {
    return {
      couponCode: null,
      couponMessage: null,
    }
  },
  emits: ['onSetCouponCode'],
  methods: {
    async checkCouponIsValid(){

      // Clear message if empty input
      if (!this.couponCode || this.couponCode.length === 0) {
        this.couponMessage = null
        this.$emit('onSetCouponCode', null)
        return
      }

      // Single course (backward compatibility)
      if (this.courseId) {
        this.checkSingleCourse(this.courseId)
        return
      }

      // Multiple courses - check against all
      if (this.courseIds && this.courseIds.length > 0) {
        await this.checkMultipleCourses()
        return
      }

      // Fallback: no courses
      this.couponMessage = 'No courses available'
      this.$emit('onSetCouponCode', null)
    },

    // Existing single-course logic (unchanged)
    checkSingleCourse(courseId) {
      fetch(`${process.env.VUE_APP_BASEURI}/courses/coupon/by-course?course_id=${courseId}&coupon_code=${this.couponCode}`, {
        method: "GET",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
      })
          .then(response => {
            if (response.ok) {
              response.json().then(res => {
                this.couponMessage = res.message
                if(res.result) {
                  res.code = this.couponCode
                  res.course_id = courseId // Add course_id to response
                  this.$emit('onSetCouponCode', res)
                } else {
                  this.$emit('onSetCouponCode', null)
                }
              })
            }
            else {
              response.json().then(err => {
                if (!err.success) console.log(err)
              })
            }
          })
    },

    // NEW: Check coupon against all courses and apply to ALL eligible ones
    async checkMultipleCourses() {
      let matchedCourses = [] // Store ALL courses that match

      // Check ALL courses (don't stop at first match)
      for (const courseId of this.courseIds) {
        try {
          const response = await fetch(
              `${process.env.VUE_APP_BASEURI}/courses/coupon/by-course?course_id=${courseId}&coupon_code=${this.couponCode}`,
              {
                method: "GET",
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                },
              }
          )

          if (response.ok) {
            const res = await response.json()

            if (res.result) {
              // This course is eligible - add to matches
              matchedCourses.push({
                ...res,
                course_id: courseId,
                code: this.couponCode
              })
            }
          }
        } catch (err) {
          console.error('Coupon check error:', err)
        }
      }

      // Handle results
      if (matchedCourses.length > 0) {
        // Found at least one match
        if (matchedCourses.length === 1) {
          this.couponMessage = `Coupon applied to 1 course`
        } else {
          this.couponMessage = `Coupon applied to ${matchedCourses.length} courses`
        }

        // Emit ALL matched courses
        this.$emit('onSetCouponCode', matchedCourses)
      } else {
        // No matches
        this.couponMessage = 'Coupon not valid for any course in cart'
        this.$emit('onSetCouponCode', null)
      }
    }

  },
  props: {
    courseId: Number,      // For single course (backward compatibility)
    courseIds: Array,      // For multiple courses (NEW)
  },
}
</script>

<style scoped>
</style>
